export default class Collapsible {
    constructor(props = {}) {
        this.props = props;
        this.$trigger = this.props.$trigger;
        this.$root = this.props.$root;
        this.$body = null;

        this.init();
    }

    init() {
        if (!this.$root) {
            throw new Error('Collapsible: Root element not found!');
        }

        this.$body = this.$root.querySelector('[data-collapsible="body"]');

        if (!this.$body) {
            throw new Error('Collapsible: Body element not found!');
        }

        if (this.$trigger) {
            this.$trigger.addEventListener('click', this._handleTriggerClick.bind(this));
        }
    }

    expand() {
        const bodyHeight = this.$body.offsetHeight;
        this.$root.style.height = `${bodyHeight}px`;
        this.$root.classList.add('-expanded');
        if (this.$trigger) {
            this.$trigger.classList.add('-expanded');
        }
    }

    collapse() {
        this.$root.removeAttribute('style');
        this.$root.classList.remove('-expanded');
        if (this.$trigger) {
            this.$trigger.classList.remove('-expanded');
        }
    }

    _handleTriggerClick(event) {
        event.preventDefault();
        this.$root.classList.contains('-expanded') ? this.collapse() : this.expand();
    }
}